<script setup lang="ts">
import {ref, watch} from "vue";
import {storeToRefs} from "pinia";
import FButtonIcon from "@/lib/components/ui/FButtonIcon.vue";
import OperationEventRow from "./OperationEventRow.vue";
import {useSchedulingStore} from "@/stores/schedulingStore";
import {oplitClient} from "@/api";
import {type LoadEventRow} from "@oplit/shared-module";

const props = defineProps<{
  operation: {op_id: string};
}>();

const {selectedSimulation} = storeToRefs(useSchedulingStore());

const isOpened = ref<boolean>(false);
const latestLoadEventsRows = ref<LoadEventRow[]>([]);

watch(
  () => props.operation,
  async () => {
    const [loadEventsRows] = await oplitClient.getLatestLoadEventsRowsByOpId(
      props.operation.op_id,
      selectedSimulation.value?.id ?? "",
    );

    if (loadEventsRows) latestLoadEventsRows.value = loadEventsRows;
  },
  {immediate: true},
);
</script>

<template>
  <v-dialog
    v-if="latestLoadEventsRows.length > 0"
    v-model="isOpened"
    width="500px"
    max-height="400px"
  >
    <template #activator="{props}">
      <slot name="activator" v-bind="props">
        <FButtonIcon
          v-bind="props"
          icon-fill="currentColor"
          icon-size="12"
          icon="zap"
          is-opal-icon
          small
          square
        />
      </slot>
    </template>

    <div class="pa-4 d-flex flex-column gap-8 keep-scrollbar overflow-auto">
      <OperationEventRow
        v-for="event in latestLoadEventsRows"
        :key="`${event.event_id}${event.event_field}`"
        :event="event"
      />
    </div>
  </v-dialog>
</template>
